import Blue from '~/core';

new Blue({
  name: 'Tabs',
  selector: '.tabs ',
  setup(tabs) {
    const spacer = tabs.querySelector('.tabs__spacer');
    const nav = tabs.querySelector('.tabs__nav');
    const triggers = tabs.querySelectorAll('.tabs__tab');
    const contents = tabs.querySelectorAll('.tabs__content');
		let isClicked = false;

    const sticky = () => {
      const top = spacer.getBoundingClientRect().top;
      const containerBottom =
        tabs.getBoundingClientRect().top +
        tabs?.offsetHeight -
        nav?.offsetHeight;
      spacer.style.height = `${nav?.offsetHeight}px`;

      if (top <= 0) {
        tabs.classList.add('sticky');
        if (containerBottom <= 0) {
          tabs.classList.add('at-bottom');
        } else {
          tabs.classList.remove('at-bottom');
        }
      } else {
        tabs.classList.remove('sticky');
        tabs.classList.remove('at-bottom');
      }
    };

    const highlight = () => {
			if (!isClicked) {
				let index, min;
				contents.forEach((content, i) => {
					const { top, bottom } = content.getBoundingClientRect();
					const absTop = Math.abs(top);
					const height = window.innerHeight;
	
					if (!min) min = absTop;
	
					if ((top >= 0 && bottom <= height) || (top <= height && bottom > 0)) {
						if (absTop <= min) {
							index = i;
							min = absTop;
						}
					}
				});
	
				triggers.forEach((t, i) => {
					if (i === index) t.classList.add('is-active');
					else t.classList.remove('is-active');
				});
			}
    };

    const navigate = (trigger, i) => {
			this.$addEvents(
				trigger,
				'click',
				async (e) => {
					e.preventDefault();
					e.stopPropagation();
					const content = contents[i];
					isClicked = true;
					triggers.forEach(c => c.classList.remove('is-active'));
					e.target.classList.add('is-active');
					// if (content.classList.contains('is-active')) {
					// 	console.log("content is already active")
					// 	return;
					// }

					// let top = content.getBoundingClientRect().top;
					let top = window.pageYOffset + content.getBoundingClientRect().top;
					if (this.$screen.lg_dn.matches) {
						top = top - nav.offsetHeight;
					}
					await this.$asyncScroll({
						method: 'scrollTo',
						top
					});
					contents.forEach(c => c.classList.remove('is-active'));
					content.classList.add('is-active');
					isClicked = false;
				}
			);
    };

    triggers.forEach(navigate);

    sticky();
    highlight();
    window.addEventListener('scroll', sticky);
    window.addEventListener('scroll', highlight);
  },
});
